"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _tss = require("../styles/tss");
const useStyles = exports.useStyles = _tss.tss.create(_ref => {
  let {
    theme
  } = _ref;
  const {
    colors
  } = theme.busbud;
  const cssProperties = {
    textColor: '--_HighlightedCardWrapperLabel-color-text',
    iconColor: '--_HighlightedCardWrapperLabel-color-icon'
  };
  return {
    root: {
      display: 'flex',
      // Removes extra space caused by inline display of the `Label`
      justifyContent: 'center'
    },
    label: {
      color: `var(${cssProperties.textColor})`
    },
    icon: {
      color: `var(${cssProperties.iconColor})`
    },
    colorInformative: {
      [cssProperties.textColor]: colors.text.informative.translucent,
      [cssProperties.iconColor]: colors.icon.informative.opaque
    },
    colorNegative: {
      [cssProperties.textColor]: colors.text.negative.translucent,
      [cssProperties.iconColor]: colors.icon.negative.opaque
    },
    colorNeutral: {
      [cssProperties.textColor]: colors.text.tertiary.opaque,
      [cssProperties.iconColor]: colors.icon.secondary.opaque
    },
    colorNotice: {
      [cssProperties.textColor]: colors.text.notice.opaque,
      [cssProperties.iconColor]: colors.icon.notice.opaque
    },
    colorPositive: {
      [cssProperties.textColor]: colors.text.positive.translucent,
      [cssProperties.iconColor]: colors.icon.positive.opaque
    },
    colorSpecial: {
      [cssProperties.textColor]: colors.text.special.translucent,
      [cssProperties.iconColor]: colors.icon.special.opaque
    }
  };
});